<template>
  <div class="setComponent">
    <!-- 二级标题 -->
    <div class="title">
      <h4>{{$t("wm_lang_html_c3eb73")}}</h4>
      <el-divider></el-divider>
    </div>
    <!-- 表单 -->
    <el-form label-width="180px" class="demo-ruleForm" size="medium">
      <div style="margin: 20px auto">
        <el-button type="primary" @click="addFolder">{{$t("wm_lang_html_f3a485")}}</el-button>
      </div>
    </el-form>
    <!-- 表格 -->
    <el-table
      v-loading="isLoading"
      :element-loading-text="$i18n.t('wm_lang_20be4e')+'...'"
      size="medium"
      :data="tableData"
      style="width: 100%">
      <div v-show="!isLoading" slot="empty">{{$t("wm_lang_html_21efd8")}}</div>
      <el-table-column
        :label="$i18n.t('wm_lang_1f4c10')"
        width="450">
        <template slot-scope="scope">
          <span>{{ scope.row.displayName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="unseenCount"
        :label="$i18n.t('wm_lang_894a10')">
      </el-table-column>
      <el-table-column
        prop="mailCount"
        :label="$i18n.t('wm_lang_e4b8bb')">
      </el-table-column>
      <el-table-column
        width="100"
        :label="$i18n.t('wm_lang_58f966')">
        <template slot-scope="scope">{{ bytesToSize(scope.row.mailSize) }}</template>
      </el-table-column>
       <el-table-column
        fixed="right"
        :label="$i18n.t('wm_lang_2b6bc0')"
        width="160">
        <template slot-scope="scope">
          <el-link type="danger" @click="emptyFolder(scope.row)" :underline="false">{{$t("wm_lang_html_288f0c")}}</el-link>
          <el-link v-if="scope.row.folderId > sysFolderIdMax" type="primary" @click="editFolder(scope.row)" :underline="false">{{$t("wm_lang_html_95b351")}}</el-link>
          <el-link v-if="scope.row.folderId > sysFolderIdMax" type="primary" @click="deleteFolder(scope.row)" :underline="false">{{$t("wm_lang_html_2f4aad")}}</el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新建文件夹模态框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="520px">
      <el-form :model="form" :rules="rules" ref="ruleForm" class="form-setting">
        <el-form-item :label="$i18n.t('wm_lang_a98473')" prop="name" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" :placeholder="$i18n.t('wm_lang_5df03b')"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_22b234')" :label-width="formLabelWidth">
          <el-select v-model="belongFolder" :placeholder="$i18n.t('wm_lang_c2b9f4')" style="max-width:270px;">
            <el-option :label="$i18n.t('wm_lang_c2b9f4')" :value="0"></el-option>
            <el-option v-for="(item, index) in form.folders" :key="index" :label="item.displayName" :value="item.folderId" style="width:270px;"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>
      </div>
    </el-dialog>
    <br><br>
  </div>
</template>

<script>
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import { bytesToSize, getFolderPathName } from '@/utils/utils';
export default {
  name: 'setComponent',
  data () {
    let folderNameVerify = (rule, value, callback) => {
      let reg = /[\/\:\*\?\"\<\>\|\ \\\+\']+/g;
      if (value.match(reg)) {
        callback(new Error(this.$i18n.t('wm_lang_6f67c4')+"\\ \/ \: \* \? \" \< \> \| \+ \' "+ this.$i18n.t('wm_lang_html_fcbc6a')));
      } else {
        //
        callback();
      }
    };
    let configSetting = storeLocal.get('Pwm-configSetting');
    return {
      dialogFormVisible: false,
      dialogTitle: this.$i18n.t('wm_lang_f3a485'),
      form: {
        name: '',
        folders: []
      },
      sysFolderIdMax: xmail.enums.SysMailFolderId.MAX,
      isEdit: false,
      folderOrg: [],
      belongFolder: 0,
      currFolder: '',
      formLabelWidth: '140px',
      // 表格
      tableData: [],
      // 表单
      ruleForm: {
        //
      },
      rules: {
        name: [
          { required: true, message: this.$i18n.t('wm_lang_47631c'), trigger: 'blur' },
          { max: configSetting.globalConfig.fieldLengthLimit.folderLimit.folderName,
            message: `${this.$i18n.t('wm_lang_379b24')}${configSetting.globalConfig.fieldLengthLimit.folderLimit.folderName}${this.$i18n.t('wm_lang_15d410')}`,
            trigger: 'blur' },
          { validator: folderNameVerify, trigger: 'blur' }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: this.$i18n.t('wm_lang_e10150'), trigger: 'blur' }
        ]
      },
      // 上传头像
      imageUrl: '',
      isLoading: false
    }
  },
  mounted() {
    this.getFolders();
  },
  watch: {
    $route(to, from) {
      this.getFolders();
    }
  },
  methods: {
    bytesToSize(bytes) {
      return bytesToSize(bytes)
    },
    addFolder() {
      this.dialogTitle = this.$i18n.t('wm_lang_f3a485');
      this.dialogFormVisible = true;
      this.form.name = '';
      this.belongFolder = 0;
      this.isEdit = false;
    },
    editFolder(folder) {
      this.dialogFormVisible = true;
      this.dialogTitle = this.$i18n.t('wm_lang_958962');
      this.form.name = folder.displayName.split('/').pop();
      this.currFolder = folder.folderId;
      this.belongFolder = folder.parentFolderId;
      this.isEdit = true;
    },
    deleteFolder(folder) {
      if(folder.folderId <= 128) {
       this.$message({
         type: 'warning',
         message: this.$i18n.t('wm_lang_572fc4')+'!'
       });
        return;
      }
      this.$confirm(`${this.$i18n.t('custom_lang_0006')}<br/>${folder.displayName}`, this.$i18n.t('wm_lang_c45357'), {
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Folder.delFolderWebMailParamBuilder();
          pm.folderId = folder.folderId;
          api.Folder.delFolderWebMail(pm, function (res) {
            self.getFolders();
            if(res.data.code === 0) {
              self.$EventBus.$emit('refreshFolders');
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_0007d1')+'!'
              });
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }).catch(() => {
        //
      });
    },
    emptyFolder(folder) {
      this.$confirm(`${this.$i18n.t('custom_lang_0073')}<br/>${folder.displayName}`, this.$i18n.t('wm_lang_c45357'), {
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Folder.cleanFolderParamBuilder();
          pm.folderId = folder.folderId;
          api.Folder.cleanFolder(pm, function (res) {
            // console.log(res)
            if(res.data.code === 0) {
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_2685dc')+'!'
              });
              self.getFolders();
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }).catch(() => {
        self.$message({
          type: 'info',
          message: self.$i18n.t('wm_lang_7093b9')
        });
      });
    },
    getFolders() {
      let self = this;
      this.isLoading = true;
      (function (api, enums, pms) {
        api.Folder.getFolderList({}, function (res) {
          const list = res.data.data.mailFolders;
          self.$store.commit('SET_FOLDERS',list);
          self.folderOrg = list;
          self.form.folders = self.$store.getters.folders;
          self.form.folders = self.form.folders.filter(item => item.folderId !== enums.FolderType.STAR_BOX_FOLDER_ID && item.folderId !== enums.FolderType.WAITING_BOX_FOLDER_ID && item.folderId !== enums.FolderType.BACKUP_BOX_FOLDER_ID)
          self.tableData = self.form.folders.map(({displayName, folderId, parentFolderId, unseenCount, mailCount, mailSize}) => ({displayName, folderId, parentFolderId, unseenCount, mailCount, mailSize}));
          // console.log(self.tableData)
          self.tableData = getFolderPathName(self.tableData);
          self.form.folders = getFolderPathName(self.form.folders);
          self.isLoading = false;
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    getParentsIdMap(id, pMap) {
      const folder = this.form.folders.find(item =>{
        return item.folderId === id
      });
      if (folder && folder.parentFolderId !== 0) {
        pMap.push(folder.parentFolderId);
        this.getParentsIdMap(folder.parentFolderId, pMap);
      }
    },
    // 表单
    submitForm(formName) {
      // console.log(this.currFolder);
      // console.log(this.belongFolder );
      // console.log(this.form.folders);
      let sameParentFolders = [];
      let existSame = false;
      this.folderOrg.forEach(item =>{
        if(item.parentFolderId === this.belongFolder) {
          sameParentFolders.push(item);
        }
      });
      // 添加文件夹
      sameParentFolders.forEach(item =>{
        let fName = item.displayName.split('/').pop();
        if(fName === this.form.name) {
          existSame = true;
        }
      });
      if(existSame) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_ea8b1d')+','+this.$i18n.t('wm_lang_5d44d9')
        });
        return;
      }
      if(this.currFolder === this.belongFolder) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_d6aac9')+','+this.$i18n.t('wm_lang_333e4b')
        });
        return;
      }
      if (this.isEdit) {
        let pMap = [];
        this.getParentsIdMap(this.belongFolder, pMap);
        if(pMap.includes(this.currFolder)) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('wm_lang_d6aac9')+','+this.$i18n.t('wm_lang_cc97eb')
          });
          return;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          let self = this;
          if(self.isEdit) {
            (function (api, enums, pms) {
              let pm = pms.Folder.updateFolderParamBuilder();
              pm.name = self.form.name;
              pm.folderId = self.currFolder;
              pm.parentFolderId = self.belongFolder;
              api.Folder.updateFolder(pm, function (res) {
                self.getFolders();
                if(res.data.code === 0) {
                  self.$message({
                    type: 'success',
                    message: self.$i18n.t('wm_lang_3bb47b')+'!'
                  });
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          } else {
            (function (api, enums, pms) {
              let pm = pms.Folder.addFolderParamBuilder();
              pm.name = self.form.name;
              pm.parentFolderId = self.belongFolder;
              api.Folder.addFolder(pm, function (res) {
                self.getFolders();
                if(res.data.code === 0) {
                  self.$EventBus.$emit('refreshFolders');
                  self.$message({
                    type: 'success',
                    message: self.$i18n.t('wm_lang_3fdaea')+'!'
                  });
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields();
    },
    // 上传头像
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(this.$i18n.t('wm_lang_397654')+' JPG '+this.$i18n.t('wm_lang_e3127c')+'!');
      }
      if (!isLt2M) {
        this.$message.error(this.$i18n.t('wm_lang_80ef9d')+' 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/folderManage.vue